/* Santas Vault - change the artwork without leaving the product page.
   ------------------------------------------------------------------
   Picking a swatch does five things and navigates for none of them:

     1 fetches /products/<handle>.js for the design that was picked;
     2 swaps the main gallery image and the print preview art;
     3 swaps the price;
     4 REWRITES #sv-variants with that product's variants, which is what makes
       Add to cart post the right thing: sv-multi.js re-reads that script on
       every submit, so it picks up the new table with no changes of its own;
     5 pushes the new URL with replaceState, so a refresh or a share lands on
       the design the shopper is actually looking at rather than the one they
       started from.

   THE SIZE AND COLOUR SURVIVE THE SWAP. Every design of the same kind carries
   the same option set, so the shopper's Large / Navy is re-applied to the new
   product rather than reset to the first variant. Resetting it is the thing
   that makes a picker like this feel broken.

   IT FAILS QUIETLY. If the fetch fails the swatch links to the product page the
   old way, so the worst case is the behaviour we had yesterday.
*/
(function () {
  var PAGE = 24;

  function $(s, r) { return (r || document).querySelector(s); }
  function el(t, c, h) { var n = document.createElement(t); if (c) n.className = c;
                         if (h != null) n.innerHTML = h; return n; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  /* THE DESIGN INDEX STORES FILE NAMES, NOT ADDRESSES. create_index moved to
     {cdn, designs:[..., 'name_600x.jpg?v=...']} and this script kept using the
     name as an address, so every artwork tile on every personalised product
     page asked /products/<name>.jpg and got a 404 (found 22 Sep 2026: 24 of 24
     tiles broken on a sack page). The prefix comes off the index itself. */
  var CDN = '';
  /* 0.27.0 (audit M8): the index names carry Shopify's legacy "_600x" size suffix, which
     makes the CDN serve 600 px whatever width is asked for (90 KB for a 75 px tile), and this
     function only replaced an existing width= so a ?v= url never got one at all. Strip the
     suffix, then set the width. Measured: 90,421 bytes before, 11,552 after at 160 px. */
  function thumb(u, w) {
    if (!u) return '';
    if (!/^(https?:)?\/\//.test(u)) u = CDN + u;
    u = u.replace(/_(\d+x\d*|\d*x\d+)(?=\.(jpe?g|png|webp|gif)(\?|$))/i, '');
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function boot(root) {
    var kind = root.getAttribute('data-kind');
    var state = { data: null, theme: null, shown: PAGE, current: root.getAttribute('data-design') };

    function list() {
      return state.data.designs.filter(function (d) {
        if (d[4].indexOf(kind) < 0) return false;
        if (state.theme && d[2] !== state.theme) return false;
        return true;
      });
    }

    function handleFor(d) {
      return (d[6] && d[6][kind]) || (d[5] + (state.data.sfx[kind] || ''));
    }

    /* ------------------------------------------------------------- swap */
    /* 0.46.2: A PICK OPENS THAT DESIGN'S OWN PAGE. Tony, on the Greyhound stocking after picking Golden Bell and
       Holly: the heading and address changed but the photos still showed the greyhound ("when you open the product
       its not changing the artwork"). The in-page swap below changed one <img> (Horizon's gallery has several, and a
       slideshow copy for phones), not the breadcrumb, the colour photos, the set box or the description. So the pick
       now loads the design's own page, which is right by construction, and carries what the shopper had: the
       variant (size and colour, by option name), the typed name, the theme chip, how far the grid was opened, and
       the scroll position, so it lands looking like an in-place swap. */
    function pick(d, tile) {
      var handle = handleFor(d);
      if (!handle) return;
      root.classList.add('is-busy');
      var want = chosenOptions(), url = '/products/' + handle;
      var nm = document.querySelector('.sv-item .sv-name, #sv-name-1');
      var name = nm && nm.value ? nm.value.trim() : '';
      try {
        sessionStorage.setItem('sv-sw-restore', JSON.stringify({ h: handle, y: window.scrollY, theme: state.theme, shown: state.shown, t: Date.now() }));
      } catch (e) {}
      function go(vid) {
        var q = [];
        if (vid) q.push('variant=' + vid);
        if (name) q.push('name=' + encodeURIComponent(name));
        location.href = url + (q.length ? '?' + q.join('&') : '');
      }
      fetch(url + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var names = (p.options || []).map(function (o) { return o.name || o; });
          var cur = document.querySelector('form[action*="/cart/add"] [name="id"]');
          var curV = null;
          try {
            var tbl = JSON.parse(($('#sv-variants') || {}).textContent || '{}');
            (tbl.variants || []).forEach(function (v) { if (cur && String(v.id) === String(cur.value)) curV = v; });
            if (curV && tbl.options) tbl.options.forEach(function (o, i) { if (want[o.name] == null) want[o.name] = curV.options[i]; });
          } catch (e) {}
          var best = null;
          (p.variants || []).forEach(function (v) {
            var ok = names.every(function (n, i) { return want[n] == null || v.options[i] === want[n]; });
            if (ok && !best) best = v;
          });
          go(best && best.id);
        })
        .catch(function () { go(null); });
    }

    function chosenOptions() {
      var out = {};
      var sel = document.querySelectorAll('.sv-perso select[data-opt], .sv-item select');
      for (var i = 0; i < sel.length; i++) {
        var n = sel[i].getAttribute('data-opt') || sel[i].name || '';
        if (n) out[n] = sel[i].value;
      }
      return out;
    }
    function restoreOptions(want, p) {
      var sel = document.querySelectorAll('.sv-perso select[data-opt], .sv-item select');
      for (var i = 0; i < sel.length; i++) {
        var n = sel[i].getAttribute('data-opt') || sel[i].name || '';
        if (want[n] != null) {
          var ok = false;
          for (var j = 0; j < sel[i].options.length; j++) {
            if (sel[i].options[j].value === want[n]) { ok = true; break; }
          }
          if (ok) sel[i].value = want[n];
        }
      }
    }

    /* ------------------------------------------------------------- draw */
    function mark() {
      var t = root.querySelectorAll('.sv-swtile');
      for (var i = 0; i < t.length; i++) {
        t[i].classList.toggle('is-on', t[i].dataset.id === state.current);
      }
    }

    function drawThemes() {
      var wrap = $('[data-sw-themes]', root);
      wrap.innerHTML = '';
      var mine = state.data.designs.filter(function (d) { return d[4].indexOf(kind) >= 0; });
      var counts = {};
      mine.forEach(function (d) { counts[d[2]] = (counts[d[2]] || 0) + 1; });
      function chip(key, label, n) {
        var b = el('button', 'sv-swchip', esc(label) + '<span>' + n + '</span>');
        b.type = 'button';
        b.addEventListener('click', function () {
          state.theme = key; state.shown = PAGE; drawGrid();
          var all = wrap.querySelectorAll('.sv-swchip');
          for (var i = 0; i < all.length; i++) all[i].classList.remove('is-on');
          b.classList.add('is-on');
        });
        return b;
      }
      var a = chip(null, 'All', mine.length);
      a.classList.add('is-on');
      wrap.appendChild(a);
      (state.data.themes || []).forEach(function (t) {
        if (counts[t[0]]) wrap.appendChild(chip(t[0], t[1], counts[t[0]]));
      });
    }

    function drawGrid() {
      var grid = $('[data-sw-grid]', root);
      var all = list();
      grid.innerHTML = '';
      all.slice(0, state.shown).forEach(function (d) {
        var b = el('button', 'sv-swtile');
        b.type = 'button';
        b.dataset.id = d[0];
        b.title = d[1];
        b.innerHTML = '<img src="' + esc(thumb(d[3], 160)) + '" srcset="' + esc(thumb(d[3], 80)) + ' 80w, ' + esc(thumb(d[3], 160)) + ' 160w, ' + esc(thumb(d[3], 260)) + ' 260w" sizes="(min-width: 750px) 90px, 25vw" alt="' + esc(d[1]) +
                      '" loading="lazy" width="260" height="260">';
        b.addEventListener('click', function () { pick(d, b); });
        grid.appendChild(b);
      });
      var more = $('[data-sw-all]', root);
      var left = Math.max(0, all.length - state.shown);
      more.hidden = left === 0;
      $('[data-sw-n]', root).textContent = left ? '(' + left + ' more)' : '';
      mark();
    }

    $('[data-sw-all]', root).addEventListener('click', function () {
      state.shown += 96; drawGrid();
    });

    fetch(root.getAttribute('data-src'))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        state.data = j;
        CDN = j.cdn || '';
        var mine = j.designs.filter(function (d) { return d[4].indexOf(kind) >= 0; });
        if (mine.length < 2) { root.hidden = true; return; }
        var back = null;
        try { back = JSON.parse(sessionStorage.getItem('sv-sw-restore') || 'null'); sessionStorage.removeItem('sv-sw-restore'); } catch (e) {}
        if (back && location.pathname.indexOf('/products/' + back.h) === 0 && Date.now() - back.t < 60000) {
          state.theme = back.theme || null; state.shown = Math.max(PAGE, back.shown || PAGE);
        } else back = null;
        drawThemes();
        if (back && back.theme) {
          var chips = root.querySelectorAll('.sv-swchip');
          for (var ci = 0; ci < chips.length; ci++) chips[ci].classList.remove('is-on');
          var tl = (state.data.themes || []).filter(function (t) { return t[0] === back.theme; })[0];
          for (var cj = 0; cj < chips.length; cj++) if (tl && chips[cj].textContent.indexOf(tl[1]) === 0) chips[cj].classList.add('is-on');
        }
        drawGrid();
        root.classList.add('is-ready');
        if (back) { var y = back.y; setTimeout(function () { window.scrollTo(0, y); }, 60); }
      })
      .catch(function () { root.hidden = true; });
  }

  function start() {
    var r = document.querySelector('[data-sv-swatch]');
    if (r && !r.dataset.svOn) { r.dataset.svOn = '1'; boot(r); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
  document.addEventListener('shopify:section:load', start);
})();
